import { useCallback } from 'react';

import { sendPostMessage } from 'v2/helpers/postMessage';
import type { PostMessageProps } from 'v2/interfaces/post-message';

export function usePostMessage(): (props: PostMessageProps) => void {
  return useCallback((props: PostMessageProps): void => {
    sendPostMessage(props);
  }, []);
}
